import { render } from "./RecFlow.vue?vue&type=template&id=5245d9cb&scoped=true"
import script from "./RecFlow.vue?vue&type=script&lang=js"
export * from "./RecFlow.vue?vue&type=script&lang=js"

import "./RecFlow.vue?vue&type=style&index=0&id=5245d9cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.35_vue@3.5.35_typescript@4.9.5__webpack@5.107.2_postcss@8.5.8_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5245d9cb"]])

export default __exports__